import { render, staticRenderFns } from "./AsociarEventosFormDetalle.vue?vue&type=template&id=23cac01d&scoped=true&"
import script from "./AsociarEventosFormDetalle.vue?vue&type=script&lang=ts&"
export * from "./AsociarEventosFormDetalle.vue?vue&type=script&lang=ts&"
import style0 from "./AsociarEventosFormDetalle.vue?vue&type=style&index=0&id=23cac01d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23cac01d",
  null
  
)

export default component.exports